/**
 * Returns true when running in a browser environment (document exists).
 * Safe to call during SSR — returns false on the server.
 */
const isBrowser = () => typeof document !== 'undefined';

export default isBrowser;
